export default function getDateHour() {
    const dataAtual = new Date();
  
    // Obtendo os componentes da data
    const ano = dataAtual.getFullYear();
    const mes = String(dataAtual.getMonth() + 1).padStart(2, "0"); // Mês começa do zero, então é necessário adicionar 1
    const dia = String(dataAtual.getDate()).padStart(2, "0");
  
    // Obtendo os componentes da hora
    const horas = String(dataAtual.getHours()).padStart(2, "0");
    const minutos = String(dataAtual.getMinutes()).padStart(2, "0");
    const segundos = String(dataAtual.getSeconds()).padStart(2, "0");
  
    // Construindo a string da data e hora no formato desejado
    const dataHoraFormatada = `${ano}-${mes}-${dia} ${horas}:${minutos}:${segundos}`;
  
    return dataHoraFormatada;
  }